export const FETCH_ALL = 'FETCH_ALL';
export const CREATE = 'CREATE'
export const BOOKMARK = 'BOOKMARK'
export const AUTH = 'AUTH'
export const LOG_OUT = 'LOG_OUT'
export const ERROR = 'ERROR'